import { FoodKind, foodRegistry } from "../core/model";

export type InstructionsContent = {
  title: string;
  legendRows: Array<{ color: number; text: string }>;
  laserLevelsLines: string[];
  controlsLines: string[];
};

// Order: existing foods first, then anything new gets appended automatically
const DEFAULT_ORDER: FoodKind[] = [
  FoodKind.Normal,
  FoodKind.Gold,
  FoodKind.Blue,
  FoodKind.Laser,
];

export function getInstructionsContent(): InstructionsContent {
  const allKinds = Object.values(FoodKind) as FoodKind[];
  const extraKinds = allKinds.filter((k) => !DEFAULT_ORDER.includes(k));
  const ordered = [...DEFAULT_ORDER, ...extraKinds].filter((k) => !!foodRegistry[k]);

  return {
    title: "How to play",
    legendRows: ordered.map((k) => ({
      color: foodRegistry[k].color,
      text: foodRegistry[k].label,
    })),

    laserLevelsLines: [
      "Levels 1–10: reach the target score to clear each level.",
      "Charged foods attach ammo to the NEW tail segment you gain.",
      "SPACE fires using the last charged tail segment (dead-tail only).",
      "Unlocks: Triple-beam at Lvl 5, Lightning at Lvl 9.",
    ],

    controlsLines: [
      "Arrow keys – move the snake",
      "SPACE – start game / shoot (consumes tail ammo)",
      "Choose a starting level from the menu",
      "Tip: the board wraps, but hitting your own tail still kills you.",
    ],
  };
}
